var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgActivecampaign = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1410092480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M7.90901 6.0649C7.73999 5.92003 0.85871 1.1152 0.544827 0.922044L0.448242 0.849609V2.03271C0.448242 2.41903 0.641405 2.53975 0.882854 2.73291L0.931139 2.75705C1.26917 2.9985 6.17058 6.40293 6.82249 6.86168C6.17058 7.32043 1.19674 10.7732 0.882854 10.9663C0.496536 11.2078 0.472389 11.3768 0.472389 11.7148V12.8496C0.472389 12.8496 7.78828 7.75504 7.93315 7.63432C8.27117 7.39287 8.34361 7.07899 8.34361 6.88583V6.74096C8.34361 6.49951 8.19874 6.25806 7.90901 6.0649Z",
    fill: "#004CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M3.61116 7.39318C3.80432 7.39318 3.99748 7.32074 4.19064 7.17587C4.43209 7.00686 4.6494 6.86199 4.6494 6.86199L4.72183 6.8137L4.6494 6.76541C4.62525 6.74126 1.41398 4.51994 1.07596 4.30263C0.931086 4.18191 0.737929 4.15776 0.617204 4.2302C0.49648 4.30263 0.399902 4.42336 0.399902 4.61652V5.36501L0.424049 5.38915C0.448194 5.4133 2.64537 6.93442 3.07998 7.22416C3.27314 7.34489 3.44215 7.39318 3.61116 7.39318Z",
    fill: "#004CFF"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActivecampaign);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Activecampaign.4e88c63bfbca326c7b002776acb06021.svg";